import React, { useState } from "react";
import { Grid } from "@material-ui/core";

import BreadcrumbAndTitle from "@components/BreadcrumbAndTitle";
import { BreadcrumbChild } from "@components/BreadcrumbCustom";

import ROUTES from "@config/routes";

import NotificationFormikContainer from "../resource/form/NotificationFormikContainer";
import { NotificationFormModeEnum } from "../resource/form/hook/interface";

const EditNotification: React.FC = () => {
  const [refId, setRefId] = useState<string>();

  const breadcrumbData: BreadcrumbChild[] = [
    { label: "Início", link: ROUTES.ADMIN_ROUTES.HOME },
    { label: "Notificações", link: ROUTES.ADMIN_ROUTES.NOTIFICATIONS.ROOT },
    { label: refId ? `Editar #${refId}` : "Editar" },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <BreadcrumbAndTitle
          breadcrumbData={breadcrumbData}
          title={refId ? `Editar notificação #${refId}` : "Editar notificação"}
        />
      </Grid>

      <Grid item xs={12}>
        <NotificationFormikContainer
          mode={NotificationFormModeEnum.EDIT}
          onRefIdLoaded={setRefId}
        />
      </Grid>
    </Grid>
  );
};

export default EditNotification;
